window.LimiteCreditoController = ControllerBase.extend({

    name: 'LimiteCreditoController',
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                 ? this.cliente
                 : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    ajax: function() {

        return {
            url: "/Cliente/_LimiteCredito",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: this.pesquisa
            })
        };
    },

    antesBinding: function () {
        this.appendToModel({ name: "Historicos", value: [] });
    },

    pesquisarHistorico: function (model, e, pagina) {

        var self = this;

        var filtros = {
            CodigoCliente: this.pesquisa.CodigoCliente,
            TamanhoPagina: 10,
            NumeroPagina: pagina || 1
        };

        global.ajax({
            url: "/Cliente/ListarHistoricoLimiteCredito",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: filtros
            }),
            success: function (data) {
                if (!data) {
                    return;
                }

                if (data.Entities && data.Entities.length > 0) {
                    self.model.Limite(data.Entities[0].Limite);
                }

                var m = ko.mapping.fromJS(data.Entities);
                self.model.Historicos(m());

                self.paginador = new Paginator({
                    container: "#page-historico-limite-credito",
                    data: data,
                    pageClickCallback: $.proxy(self.paginar, self)
                });
            }
        });
    },

    paginar: function(e) {
        this.pesquisarHistorico(null, null, e.page);
    },

})